const state = () => ({
  message: '',
  type: ''
})

const mutations = {
  SHOW_MESSAGE (state, payload) {
    state.message = payload.message
    state.type = payload.type
  }
}

export default {
  state,
  mutations
}
